import BotFilter from '@/services/rest/bemob/bot-filter';
import UserApi from '@/services/rest/bemob/user';

export class BotFiltersApi {
  loading: boolean = false;
  error: boolean = false;

  data: any = {}; //will keep data here
  dataFilter: any = {}; //will keep data here

  api: BotFilter = new BotFilter();
  userApi: UserApi = new UserApi();


  get() {
    this.loading = true;
    // @ts-ignore
    return this.api.getList().then((payload: any) => {
      this.data = payload;
      this.loading = false;
      return payload;
    });
  }

  getById(id: string) {
    this.loading = true;
    // @ts-ignore
    return this.api.get(id).then((payload: any) => {
      this.dataFilter = payload;
      this.loading = false;
      return payload;
    });
  }

  putRules(id: string, payload: object) {
    return this.api.putUpdate(id, payload).then((res) => {
      //this.data = res;
      this.loading = false;
      return res
    });
  }

  put(payload: object) {
    return this.userApi.putUser(payload).then((res: any) => {
      this.loading = false;
      console.time('put');
      return Promise.resolve(res);
      //return res
    });
  }

  post(data: object) {
    this.loading = true;
    // @ts-ignore
    return this.api.postCreate(data).then((payload: any) => {
      this.loading = false;
      return payload;
    });
  }

  delete(id: string) {
    return this.api.delete(id).then((payload: any) => {
    });
  }

}

export default new BotFiltersApi();
